import { schema as schemas } from 'normalizr'
import { CallApi } from '@signavio/kraken'

import compositeId from '../../compositeId'

export const collection = 'dataTypeDescriptors'

const dataTypeDescriptorSchema = new schemas.Entity(
  collection,
  {},
  { idAttribute: compositeId('key', 'id') }
)

export const schema = new schemas.Array(dataTypeDescriptorSchema)

export const fetch = (callApi: CallApi, apiBase: string) => () =>
  callApi(`${apiBase}/typeDescriptors`, schema)
